export default __webpack_public_path__ + "static/media/icon_dd_provider.6e30cbcc.svg";